// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Zd","subtitle":"_d","contentWrap":"ae","imgWrap":"be","heading":"ce","copy":"de"};